/**
 * @file   src\components\MemberWantAd\TopRightBtn.js
 * @brief  This file is responsible for save and exit in member want ad creation.
 * @date   June, 2023
 * @author ZCO Engineer
 * @copyright (c) 2023, ZCO
 */
import React from "react";
import Button from "react-bootstrap/Button";

const TopRightBtn = (props) => {
  const {
    exitButtonText,
    handleSaveAndExit,
    step,
    exitButtonDisable,
    isFinalStep,
    hideContinueButton,
    handleContinueClick,
    continueButtonText,
    isDisabled,
  } = props;
  return (
    <div className="align-self-end">
      {!exitButtonDisable && !isFinalStep && (
        <Button
          variant="primary"
          className="btn-grey"
          onClick={() => handleSaveAndExit(step)}
        >
          {exitButtonText}
        </Button>
      )}
      {!hideContinueButton && isFinalStep && (
        <Button
          variant="primary"
          className="ms-0 me-0"
          disabled={isDisabled}
          onClick={() => handleContinueClick(step)}
        >
          {continueButtonText || "Continue"}
        </Button>
      )}
    </div>
  );
};
export default TopRightBtn;
